export const ConnectionMemoFields = [
  {
    id: Math.random() * 10,
    name: "Connection_Memo",
    fields: [
      {
        name: "Date",
        label: "Date",
        type: "Date",
      },
      {
        name: "From_Connection_Center",
        label: "From Warehouse",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        Reference_field: "To_Connection_Center",
        masterName: "Warehouse_Name",
      },
      {
        name: "To_Connection_Center",
        label: "To Warehouse",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        Reference_field: "From_Connection_Center",
        masterName: "Warehouse_Name_Without_Branch",
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Voucher_Series",
      //   label: "Book Code ",
      //   masterName: "Voucher_Series",
      //   variable: {
      //     Voucher_Type: "Connection Memo",
      //   },
      //   type: "InputDropForQuery",
      // },
      {
        id: Math.random() * 10,
        name: "Invoice_No",
        label: "Challan No",
        type: "text",
        icon: "IoSettingsOutline",
        disabled: true,
      },
      {
        name: "Mode",
        type: "inputdrop",
        dropdowncontent: ["Truck", "Train", "Flight", "Vessel"],
      },
      {
        name: "Vehicle_No",
        label: "Vehicle No",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        Reference_field: "Mode",
        masterName: "searchTransportModeData",
      },
      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "DriverNameData",
      },
      {
        name: "Driver_No",
        label: "Driver No",
        type: "number",
        component: "Input",
        min: 10,
        max: 10,
      },
      {
        id: Math.random() * 10,
        name: "Vendor_ID",
        label: "Vendor",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "Vendor_Account",
      },
      {
        name: "Vendor_Document_No",
        label: "Vendor Doc No",
        type: "text",
        component: "Input",
        AllCaps: true,
      },
    ],
  },
];

export const ConnectionMemoDocumentFields = [
  {
    name: "Approval",
    label: "Approval",
  },
  {
    name: "Request",
    label: "Request",
  },
  {
    name: "Invoice_1",
    label: "Invoice 1",
  },
  {
    name: "Invoice_2",
    label: "Invoice 2",
  },
  {
    name: "Eway_Bill_1",
    label: "Eway Bill 1",
  },
  {
    name: "Eway_Bill_2",
    label: "Eway Bill 2",
  },
  {
    name: "POD",
    label: "POD",
  },
  {
    name: "Other_Document",
    label: "Other Document",
  },
];

export const ConnectionMemoConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Voucher_Series",
        label: "Default Voucher Series",
        type: "InputDropForQuery",
        masterName: "Voucher_Series",
        variable: {
          Voucher_Type: "Connection Memo",
        },
        min: 0,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_Update_EWB",
        label: "Default Update EWB",
        type: "inputdrop",
        dropdowndata: ["YES", "NO"],
      },
    ],
  },
];

export const VoucherConfig = [
  {
    id: Math.random() * 10,
    name: "Book_Code_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Voucher_Series",
        label: "Book Code ",
        masterName: "Voucher_Series",
        // dropdowndata: GetBookCodes,
        variable: {
          Voucher_Type: "Connection Memo",
        },
        type: "InputDropForQuery",
      },
      {
        id: Math.random() * 10,
        name: "Bill_No",
        label: "Next Number",
        type: "number",

        min: 5,
        max: 5,
      },
    ],
  },
];

export const ConnectionMemoChargesField = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges",
    fields: [
      {
        id: Math.random() * 10,
        name: "Total_Weight",
        label: "Total Weight",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Rate",
        label: "Rate",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_On",
        label: "Freight On",
        type: "inputdrop",
        dropdowncontent: ["Weight", "Fixed"],
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Docket_Amount",
        label: "Docket Amount",
        value: 0,
        type: "number",
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Pickup_Charges",
      //   label: "Pickup Charges",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Delivery_Charges",
      //   label: "Delivery Charges",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "FOV",
      //   label: "FOV",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "FSC",
      //   label: "FSC",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      {
        id: Math.random() * 10,
        name: "Holding_Charge",
        label: "Holding Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charge",
        label: "Other Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charge_Two",
        label: "Other Charges 2",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Total",
        label: "Total",
        formula: [
          { name: "Freight_Amount", opt: "+" },
          { name: "Docket_Amount", opt: "+" },
          { name: "Pickup_Charges", opt: "+" },
          { name: "Delivery_Charges", opt: "+" },
          { name: "FOV", opt: "+" },
          { name: "FSC", opt: "+" },
          { name: "Hamali_Charge", opt: "+" },
          { name: "Holding_Charge", opt: "+" },
          { name: "Other_Charge", opt: "+" },
          { name: "Other_Charge_Two", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];
